
export * from '@ms/telemetry-manager/lib/events/ResultTypeEnum';
